import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
// import { Action } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import DropDown from '@/common/dropdown.vue';
import BackTop from '@/common/backtop.vue';
import NavMenu from '@/common/navmenu.vue';
// import {
//   refundType,
//   reasonList,
//   uploadFile,
//   addressList,
//   saveAddress
// } from '@/services/http';
// import { validateTelPhone } from '@/tools/regexp';
// import { readCookie } from '@/tools/tools';
// import addData from '../../assets/json/address.json';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {}
  }, {
    key: "checkOrder",
    value: function checkOrder() {
      this.$router.push('/exchange-list?status=0');
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    DropDown: DropDown,
    BackTop: BackTop,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;